import { render, staticRenderFns } from "./ConfirmBuyModal.vue?vue&type=template&id=e6dc3ae2&"
import script from "./ConfirmBuyModal.vue?vue&type=script&lang=js&"
export * from "./ConfirmBuyModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports